import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const TokenContext = createContext(null);

export const TokenProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const generateToken = useCallback(async () => {
        try {
            const { REACT_APP_BASE_URL, REACT_APP_USERNAME, REACT_APP_PASSWORD } = process.env;
            const headers = { username: REACT_APP_USERNAME, password: REACT_APP_PASSWORD };
            const res = await axios.get(`${REACT_APP_BASE_URL}/index.php?r=api/token`, { headers });
            const token = res?.data?.token;
            if (token) {
                localStorage.setItem('token', token);
                setToken(token);
            }
        } catch (err) {
            console.error('Token error:', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const validateToken = useCallback(async (storedToken) => {
        const { REACT_APP_BASE_URL } = process.env;
        try {
            await axios.get(`${REACT_APP_BASE_URL}/index.php?r=api/auth/validate`, {
                headers: {
                    'x-authorization-token': storedToken
                }
            });
            setToken(storedToken);
        } catch (error) {
            if (error.response?.status === 406) {
                await generateToken();
            } else {
                setError(error);
            }
        } finally {
            setLoading(false);
        }
    }, [generateToken]);

    useEffect(() => {
        const init = async () => {
            const storedToken = localStorage.getItem('token');
            if (!storedToken) {
                await generateToken();
            } else {
                await validateToken(storedToken);
            }
        };
        init();
    }, [validateToken]);

    return (
        <TokenContext.Provider value={{ token, loading, error }}>
            {children}
        </TokenContext.Provider>
    );
};

export const useToken = () => useContext(TokenContext);
